import cn from 'classnames';

import Text from '@components/Text';
import Title from '@components/Title';
import ContractSign from '@modules/static/components/ContractSign';
import s from '@modules/static/components/StaticContract/StaticContract.module.scss';

const StaticContractAdditional = () => (
  <>
    <div className={s.chapterMain}>
      <Title className={s.title} level={2}>
        Приложение № 1
        <br />
        к Договору-оферте возмездного оказания
        <br />
        медицинских услуг, утв. «__»_______2022 г.
      </Title>

      <Text className={s.paragraph} fontgraphik>
        СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
      </Text>
    </div>

    <div className={s.chapter}>
      <Text className={s.contractRequisitesText} fontgraphik>
        Я, нижеподписавшийся (-аяся), проживающий (-ая) по адресу:
        ________________________&thinsp;_______________________, ________________ (наименование документа) серия _______
        номер ___________, выдан _____________________________&thinsp;________________&thinsp;___________________ (дата
        выдачи, сведения о выдавшем органе), в соответствии с требованиями статьи 9 Федерального закона от 27.07.06
        «О персональных данных» № 152-ФЗ, подтверждаю свое согласие на обработку (сбор, систематизацию, накопление,
        хранение, уточнение, обновление, изменение, обезличивание, уничтожение) в течение срока действия настоящего
        Договора, а также сроков, установленных для хранения документов моих персональных данных, в том числе
        о состоянии здоровья Обществом с ограниченной ответственностью «ПРОГРЕСС» (ИНН 7 714 946 124, юридический адрес:
        125 565, г. Москва, ул. Фестивальная, д. 13, корп. 2) (далее — «Общество») моих персональных данных/персональных
        данных
      </Text>
      <Text className={cn(s.contractRequisitesText, s.textCenter)} fontgraphik>
        {''}
      </Text>
      <Text size="small" className={cn(s.contractRequisitesTextBordered, s.textCenter)} fontgraphik>
        (Ф.И.О. субъекта персональных данных в случае, если Согласие подписывает представитель)
      </Text>
      <Text className={s.contractRequisitesText} fontgraphik>
        включающих: фамилию, имя, отчество, пол, дату рождения, адрес проживания, контактный телефон, иные паспортные
        данные, реквизиты полиса ОМС (ДМС), страховой номер Индивидуального лицевого счета в Пенсионном фонде России
        (СНИЛС), данные о состоянии здоровья, историях болезни и результатах лабораторных исследований, случаях
        обращения за медицинской помощью и в медико-профилактических целях, в целях установления медицинского диагноза
        и оказания медицинских услуг при условии, что их обработка осуществляется лицом, профессионально занимающимся
        медицинской деятельностью и обязанным сохранять врачебную тайну.
        <br />
        В процессе оказания Обществом мне (Клиенту) медицинской помощи я предоставляю право медицинским работникам
        Общества передавать мои персональные данные (персональные данные Клиента), содержащие сведения, составляющие
        врачебную тайну, другим должностным лицам Общества, а также медицинским учреждениям-партнерам в интересах моего
        обследования и лечения.
        <br />
        Я предоставляю Обществу право на использование персональных данных в целях информирования меня с помощью средств
        связи (в т. ч. интернета, телефонной связи) о перечне медицинских услуг, оказываемых Обществом, о скидках
        и акциях на медицинские услуги, об изменениях порядка предоставления медицинских услуг, о записи на прием
        к врачу, о результатах медицинских обследований:
        <br />
        Срок хранения моих персональных данных (персональных данных Клиента) соответствует сроку хранения первичных
        медицинских документов и составляет <b>двадцать пять лет</b> (для стационара), <b>пять лет</b> (для
        поликлиники).
        <br />
        Передача моих персональных данных иным лицам или иное их разглашение может осуществляться только с моего
        письменного согласия.
        <br />
        Настоящее согласие дано мной _______________(дата), начинает свое действие с даты его подписания и действует
        на весь срок хранения моих персональных данных (персональных данных Клиента).
        <br />
        Я оставляю за собой право отозвать свое согласие посредством направления соответствующего письменного
        уведомления, которое может быть направлено мной в адрес Общества по почте заказным письмом с уведомлением
        о вручении либо вручен лично под расписку представителю Общества.
        <br />
        В случае получения моего письменного заявления об отзыве настоящего согласия на обработку персональных данных,
        Общество обязано прекратить их обработку в течение периода времени, необходимого для завершения взаиморасчетов
        по оплате оказанной мне до этого медицинской помощи.
      </Text>

      <div className={s.contractRequisitesFooterSign}>
        <div className={s.contractRequisitesFooterSignContent}>
          <Text className={s.contractRequisitesTitle}>Клиент:</Text>
          <ContractSign />
        </div>
      </div>
    </div>
  </>
);

export default StaticContractAdditional;
